export default "300ad7ead0df793f.svg"